import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {SignInComponent} from './sign-in/sign-in.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {ForgotPasswordSubmitComponent} from './forgot-password/forgot-password-submit.component';
import {LicenceComponent} from './licence/licence.component';
import {ChangePasswordComponent} from '../shared/change-password/change-password.component';
import {ChangePasswordSubmitComponent} from '../shared/change-password/change-password-submit.component';
import {AuthGuard} from './auth.guard';
import { AngularTokenService } from '@lakshvairav/angular-token';
import { AuthModule } from './auth.module';
// AngularTokenService
const routes: Routes = [
  {path: 'sign-in', component: SignInComponent},
  { path: 'forgot-password', component: ForgotPasswordComponent},
  { path: 'forgot-password-submit', component: ForgotPasswordSubmitComponent},
  { path: 'licence-terms', component: LicenceComponent, canActivate: [AuthGuard]},
  { path: 'change-password', component: ChangePasswordComponent, canActivate: [AuthGuard]},
  { path: 'change-password-submit', component: ChangePasswordSubmitComponent, canActivate: [AuthGuard]},
  { path: 'change-password-submit', component: ChangePasswordSubmitComponent, canActivate: [AuthGuard]}
];
export const auth_routing: ModuleWithProviders<AuthModule> = RouterModule.forChild(routes);
